export const NAV_LABELS = {
  pricing: "Planes y Precios",
  pricingTable: "Comparar Planes",
  pricingFaq: "FAQs de Planes",
  brokersDirectory: "Asesores Inmobiliarios",
  collaborationInventory: "Inventario para Colaboración",
};

export const ACTIVATION_UI_COPY = {
  basicAccountReviewDescription:
    "Consulta tu tipo de cuenta, límites vigentes y la activación de suscripción desde Mi Cuenta.",
  basicUpgradeHint:
    "Activa Pro desde Mi Cuenta cuando necesites publicar más propiedades y usar herramientas operativas.",
  brokerPendingProfile:
    "Mientras no tengas una suscripción activa, tu perfil de asesor no aparece en el directorio público. Al activar, tu perfil se publica automáticamente. Si tu pago se pausa, se oculta hasta que reactives.",
  brokerInventoryNeedsActive:
    "Necesitas una suscripción activa para acceder al inventario de colaboración. Retoma la activación desde Mi Cuenta.",
};